export const HOURLY_SHOOT_CATEGORY_OPTIONS = [
    { value: "", label: "Select Category" },
    { value: "Corporate Shoot", label: "Corporate Shoot" },
    { value: "Automobile Shoot", label: "Automobile Shoot" },
    { value: "Event Shoot", label: "Event Shoot" },
    { value: "Wedding Shoot", label: "Wedding Shoot" },
    { value: "Fashion Shoot", label: "Fashion Shoot" },
    { value: "Sports Shoot", label: "Sports Shoot" },
    { value: "Food Shoot", label: "Food Shoot" },
    { value: "Maternity & Baby Shoot", label: "Maternity & Baby Shoot" },
    { value: "Product Shoot", label: "Product Shoot" },
];
